import { bankLogo } from './bankLogos';
import { bankMeta, bankLabel } from './format';
import './BankMark.css';

/**
 * Banka göstergesi — tablolarda ve modalda ortak. Logo varsa beyaz çipte logo,
 * yoksa renkli baş-harf; yanında düzgün banka adı. `nameOnly` label'ı gizler.
 */
export function BankMark({ bankKey, hideName = false }: { bankKey: string | null; hideName?: boolean }) {
  const logo = bankLogo(bankKey);
  const label = bankLabel(bankKey);
  const meta = bankMeta(bankKey);
  return (
    <span className="bankmark">
      {logo ? (
        <span className="bankmark-logo"><img src={logo} alt={label} /></span>
      ) : (
        <span className="bankmark-ini" style={{ background: meta.color }}>{meta.ini}</span>
      )}
      {!hideName && <span className="bankmark-label">{label}</span>}
    </span>
  );
}
